import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { useSelector, useDispatch } from 'react-redux';
import { analysisData } from '../Redux/Slices/adminPortalSlice';
import './Charts.css';




let options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '80%',
    plugins: {
        legend: {
            position: 'left',
            display: true,
        },
        title: {
            color: 'rgba(0,0,0,0.7)',
            display: true,
            text: 'Browser Usage',
            font: {
                size: 20,
            },
        },
        tooltip: {
            displayColors: true,
            intersect: false,
            callbacks: {
                label: function (context) {
                    return ` ${context.label}: ${context.dataset.data[context.dataIndex]}%`;
                },
            }
        },
    }
};

const Doughnut3 = () => {
    let fetchedData = useSelector(analysisData);
    return (
        <div className="doughnut_Div">
            <Doughnut data={get_data(fetchedData.browserUsage)} options={options} />
        </div>
    );
}

export default Doughnut3;

function get_data(browser) {
    let browser_total = browser.mozilla_firefox + browser.samsung_internet + browser.opera + browser.internet_explorer + browser.microsoft_edge + browser.google_chrome + browser.safari + browser.unknown;
    let mozilla_firefox = ((browser.mozilla_firefox / browser_total)*100).toFixed(0);
    let samsung_internet = ((browser.samsung_internet / browser_total)*100).toFixed(0);
    let opera = ((browser.opera / browser_total)*100).toFixed(0);
    let internet_explorer = ((browser.internet_explorer / browser_total)*100).toFixed(0);
    let microsoft_edge = ((browser.microsoft_edge / browser_total)*100).toFixed(0);
    let google_chrome = ((browser.google_chrome / browser_total)*100).toFixed(0);
    let safari = ((browser.safari / browser_total)*100).toFixed(0);
    let unknown = ((browser.unknown / browser_total)*100).toFixed(0);
    const data = {
        labels: ['Mozilla Firefox', 'Samsung Internet', 'Opera', 'Internet Explorer', 'Microsoft Edge', 'Google Chrome', 'Safari', 'Unknown'],
        datasets: [
            {
                label: '# of Votes',
                data: [mozilla_firefox, samsung_internet, opera, internet_explorer, microsoft_edge, google_chrome, safari, unknown],
                backgroundColor: [
                    'rgba(251, 140, 0, 0.4)',
                    'rgba(123, 31, 162, 0.4)',
                    'rgba(229, 57, 53, 0.4)',
                    'rgba(0, 230, 118, 0.4)',
                    'rgb(0, 150, 136, 0.4)',
                    'rgba(33, 150, 243, 0.7)',
                    'rgba(109, 76, 65, 0.4)',
                    'rgba(0, 0, 0, 0.4)',
                ],
                borderColor: [
                    'rgba(251, 140, 0, 1)',
                    'rgba(123, 31, 162, 1)',
                    'rgba(229, 57, 53, 1)',
                    'rgba(0, 230, 118, 1)',
                    'rgb(0, 150, 136, 1)',
                    'rgba(33, 150, 243, 1)',
                    'rgba(109, 76, 65, 0.4)',
                    'rgba(0, 0, 0, 0.8)',
                ],
                borderWidth: 1.2,
            },
        ],
    };

    return (data);
}